import { gql } from 'graphql-request';

export const getUpdateOfferingsActions = gql`
  query getUpdateOfferingActions {
    requestAllPublicOfferingActions {
      offeringId
      status
      actionRef
      operatorId
      userId
      id
      user {
        email
        id
      }
      offering {
        id
        name
        status
        operatorId
        kpis {
          key
          value
        }
      }
      popUpsShown
    }
  }
`;
